import type { NewCarFuelType } from '@/apis/server/new-car/v1/types';
import {
  AUTHORISED_DISTRIBUTORS,
  PARALLEL_IMPORTERS,
  VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES,
  VEHICLE_NAME_ALL_PASSENGER_CARS,
  VEHICLE_NAME_ELECTRIC_CARS,
  VEHICLE_NAME_HATCHBACK,
  VEHICLE_NAME_HYBRID_CARS,
  VEHICLE_NAME_LUXURY_SEDAN,
  VEHICLE_NAME_MID_SIZED_SEDAN,
  VEHICLE_NAME_MPV,
  VEHICLE_NAME_SPORTS_CARS,
  VEHICLE_NAME_STATIONWAGON,
  VEHICLE_NAME_SUV,
} from '@/constants/global';

export const conditionToText: Record<string, string> = {
  '>': 'More than',
  '<': 'Less than',
  '=': 'Equal to',
};

export const categoryToText: Record<string, string> = {
  [AUTHORISED_DISTRIBUTORS]: 'Authorised Distributor',
  [PARALLEL_IMPORTERS]: 'Parallel Importer',
  a: 'Cat A COE',
  b: 'Cat B COE',
};

export const transmissionToText: Record<string, string> = {
  A: 'Auto',
  M: 'Manual',
};

export const dealerTypeToText: Record<string, string> = {
  [AUTHORISED_DISTRIBUTORS]: 'Authorised Distributor',
  [PARALLEL_IMPORTERS]: 'Parallel Importer',
};

export const fuelTypeToText: Record<NewCarFuelType, string> = {
  diesel: 'Diesel',
  'diesel-electric': 'Diesel Electric',
  electric: 'Electric',
  petrol: 'Petrol',
  'petrol-electric': 'Petrol Electric',
};

export const sortByToText: Record<string, string> = {
  asc: 'Ascend',
  desc: 'Descend',
};

export const vehicleTypeToText: Record<string, string> = {
  commercial: VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES,
  passenger: VEHICLE_NAME_ALL_PASSENGER_CARS,
  sedan: VEHICLE_NAME_MID_SIZED_SEDAN,
  luxury: VEHICLE_NAME_LUXURY_SEDAN,
  hatchback: VEHICLE_NAME_HATCHBACK,
  mpv: VEHICLE_NAME_MPV,
  suv: VEHICLE_NAME_SUV,
  sports: VEHICLE_NAME_SPORTS_CARS,
  stationwagon: VEHICLE_NAME_STATIONWAGON,
  hybrid: VEHICLE_NAME_HYBRID_CARS,
  electric: VEHICLE_NAME_ELECTRIC_CARS,
};

export const coeTypeToText: Record<string, string> = {
  a: 'Cat A COE',
  b: 'Cat B COE',
};
